module.exports = __webpack_public_path__ + "img/negy.89a84f86.jpg";